module.exports = __webpack_public_path__ + "Samsung_Tab_S3.svg?97b49bb1ace6a731f9a1ffccf8debcce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Samsung_Tab_S3.svg
// module id = 212
// module chunks = 0